import { browserHistory } from 'react-router'
import 'es6-promise/auto'
import axios from 'axios'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import { shuffleObject } from 'utilities/object'

const siteUrl = safeSiteData.site_url

export function showAdopted( bool ) {
	return {
		type: 'SHOW_ADOPTED',
		payload: bool
	}
}

export function requestAnimalsData() {
	return {
		type: 'REQUEST_ANIMALS_DATA'
	}
}

export function receiveAdoptedAnimalsData( type, data ) {
	return {
		type: 'RECEIVE_ADOPTED_ANIMALS_DATA',
		payload: {
			animalType: type,
			data: data
		}
	}
}

export function receiveAnimalsData( type, data ) {
	return {
		type: 'RECEIVE_ANIMALS_DATA',
		payload: {
			animalType: type,
			data: data
		}
	}
}

export function setAnimalsType( type ) {
	return {
		type: 'SET_ANIMALS_TYPE',
		payload: type
	}
}

export function setSelectedAnimal( id ) {
	return {
		type: 'SET_SELECTED_ANIMAL',
		payload: id
	}
}

export function setAnimalsSearch( value ) {
	return {
		type: 'SET_ANIMALS_SEARCH',
		payload: value
	}
}

export function setAnimalsPostcode( value ) {
	return {
		type: 'SET_ANIMALS_POSTCODE',
		payload: value
	}
}

export function setAnimalsPostcodeDistance( value ) {
	return {
		type: 'SET_ANIMALS_POSTCODE_DISTANCE',
		payload: value
	}
}

export function setAnimalsFilter( id, value ) {
	return {
		type: 'SET_ANIMALS_FILTER',
		payload: {
			id: id,
			value: value
		}
	}
}

export function getAnimalsData( type, adoptions = '0', pageNumber = null ) {
	return function( dispatch, getState ) {
		const animals = getState().animals

		if ( 'dog' == type && Object.keys( animals.dogsById ).length ) {
			return
		} else if ( 'cat' == type && Object.keys( animals.catsById ).length ) {
			return
		} else if ( 'other' == type && Object.keys( animals.otherById ).length ) {
			return
		}

		let url = `${safeSiteData.api_base_url}animals/?type=${type}&adoptions=${adoptions}`

		if ( pageNumber ) {
			url += `&page_number=${pageNumber}`
		}

		dispatch( requestAnimalsData() )

		return axios({
				url: url,
				timeout: 1000 * 60 * 5,
				method: 'get',
				responseType: 'json'
			})
			.then( function( response ) {
				response.data.items = shuffleObject( response.data.items )

				if ( '1' == adoptions ) {
					dispatch( receiveAdoptedAnimalsData( type, response.data ) )
				} else {
					dispatch( receiveAnimalsData( type, response.data ) )
				}
			})
			.catch( function( error ) {
				console.log( error, 'error' );
			})
	}
}

export function receiveHappyTailsData( data ) {
	return {
		type: 'RECEIVE_HAPPY_TAILS_DATA',
		payload: {
			data: data
		}
	}
}

export function getHappyTailsData() {
	return function( dispatch ) {
		return axios({
				url: safeSiteData.api_base_url + 'happy-tails/',
				timeout: 20000,
				method: 'get',
				responseType: 'json'
			})
			.then( function( response ) {
				dispatch( receiveHappyTailsData( response.data ) )
			})
			.catch( function( error ) {

			})
	}
}

export function receiveTributesData( data ) {
	return {
		type: 'RECEIVE_TRIBUTES_DATA',
		payload: {
			data: data
		}
	}
}

export function getTributesData() {
	return function( dispatch ) {
		return axios({
				url: safeSiteData.api_base_url + 'tributes/',
				timeout: 20000,
				method: 'get',
				responseType: 'json'
			})
			.then( function( response ) {
				dispatch( receiveTributesData( response.data ) )
			})
			.catch( function( error ) {

			})
	}
}

export function receiveStoriesData( data ) {
	return {
		type: 'RECEIVE_STORIES_DATA',
		payload: {
			data: data
		}
	}
}

export function getStoriesData() {
	return function( dispatch ) {
		return axios({
				url: safeSiteData.api_base_url + 'stories/',
				timeout: 20000,
				method: 'get',
				responseType: 'json'
			})
			.then( function( response ) {
				dispatch( receiveStoriesData( response.data ) )
			})
			.catch( function( error ) {

			})
	}
}

export function setLatLng( latLng ) {
	return {
		type: 'SET_LAT_LNG',
		payload: latLng
	}
}

export function getLatLng( postcode ) {
	return function( dispatch ) {
		return axios({
				url: safeSiteData.api_base_url + `lat-lng?postcode=${postcode}`,
				timeout: 20000,
				method: 'get',
				responseType: 'json'
			})
			.then( function( response ) {
				dispatch( setLatLng( response.data ) )
			})
			.catch( function( error ) {

			})
	}
}



// WEBPACK FOOTER //
// ./redux/actions/animals.jsx